<template>
    <transition name="modal" enter-active-class="animated fadeIn" appear>
        <div class="modal-mask">
            <div class="modal-wrapper">
                <div class="modal-container">
                    <div class="modal-body m-0">
                        <slot name="body">
                            <p>{{msg}}</p>


                            <br />
                            <div v-if="showInputs">
                                <div class="input-style input-style-2 has-icon input-required">
                                    <i class="input-icon fa fa-history color-magenta2-light"></i>
                                    <span class="color-highlight input-style-1-active">زمان استفاده شده</span>
                                    <input v-maska="'##:##'" placeholder="00:00" @blur="fixTime" class="form-control ltr d-inline-block" type="tel" v-model="workUsedTime">
                                </div>
                                <div class="mb-3">
                                    <v-select dir="rtl" label="title" placeholder="آخرین وضعیت" :filterable="false" :searchable="false" :options="taskTypeStepList" :reduce="p => p.taskTypeStepId" v-model="taskTypeStepId">
                                        <template slot="option"  >
                                            <div class="d-center">
                                                {{ option.title }}
                                            </div>
                                        </template>
                                    </v-select>
                                </div>
                            </div>
                            <span v-if="Loading">در حال ارسال اطلاعات...</span>
                        </slot>
                    </div>

                    <div class="modal-footer py-1 px-2">
                        <slot name="footer">
                            <button class="btn btn-xxs rounded-s bg-green2-light" @click="SaveRef">
                                <i class="fa fa-check ml-2"></i>
                                تایید
                            </button>
                            <button class="btn btn-xxs rounded-s bg-red1-light" @click="$emit('close')">
                                <i class="fa fa-times ml-2"></i>
                                انصراف
                            </button>
                        </slot>
                    </div>
                </div>
            </div>
        </div>
    </transition>



</template>
<script>
    import { maska } from 'maska'
    export default {
       directives: { maska },
        props: ['taskId', 'taskFolderId', 'progressRate'],
        data() {
            return {
                workUsedTime: null,
                taskTypeStepId: null,
                taskWorkData: null,
                Loading: false,
                msg: null,
                errorMsg: null,
                showInputs: false

            };
        },
        computed: {

            taskTypeStepList() {
                return this.$store.getters.GetTaskTypeStepList;
            },
        },

        mounted() {
            console.log("mounted");
            this.getRef();
        },
        methods: {
            getRef() {
                this.$http.get("TaskWork/TaskFolderData?id=" + this.taskFolderId)
                   .then(data => {
                        this.taskWorkData = data.data;

                        this.$store.dispatch("GetTaskTypeStepListFromServer", { taskTypeId: this.taskId });
                        this.taskTypeStepId = data.data.taskTypeStepId;

                        this.msg = "برای این "+ (this.lableText('TaskName')??'وظیفه') +" پیگیری ثبت نشده است. در صورت  تمایل اطلاعات زیر را جهت بستن "+(this.lableText('TaskName')??'وظیفه')+" وارد نموده و تایید کنید.";
                        this.showInputs = true;
                        this.workUsedTime = data.data.suggestedPersonTime;
                        this.fixTime();


                    });
            },

            SaveRef() {
                this.$http.get('taskWork/SavetaskWorkForFolder?id=' + this.taskFolderId + "&stepId=" + (this.taskTypeStepId ?? '') + "&time=" + (this.workUsedTime ?? '')).then(response => {
                    if (response.data.toString() !== "1") {
                        this.showErrorMessage(response.data);
                    }
                    else {
                        this.$emit('sendCloseTaskFolder');
                        this.showSuccessMessage("پیگیری با موفقیت ثبت شد.");

                    }
                    this.Loading = false;
                }, error => {
                    this.showErrorMessage("خطا در ارسال اطلاعات");
                    this.Loading = false;
                    console.log(error);
                });
            },
            fixTime() {
                var val = this.workUsedTime;
                if (val.length == 1) {
                    val = '0' + val + ':00';
                }
                else if (val.length == 2) {
                    val = val + ':00';
                }
                else if (val.length == 3) {
                    val = val + '00';
                }
                else if (val.length == 4) {
                    val = val + '0';
                }
                this.workUsedTime = val;
            },
        }

    };
</script>
<style>
    .modal-mask {
        position: fixed;
        z-index: 1;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        display: table;
        transition: opacity 0.3s ease;
    }

    .modal-wrapper {
        display: table-cell;
        vertical-align: middle;
    }

    .modal-container {
        width: 300px;
        margin: 0px auto;
        background-color: #fff;
        border-radius: 2px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
        transition: all 0.3s ease;
    }

    .modal-header h3 {
        margin-top: 0;
        color: #42b983;
    }

    .modal-body {
        margin: 20px 0;
        line-height: 1;
    }

    .modal-default-button {
        float: right;
    }


    .modal-enter {
        opacity: 0;
    }

    .modal-leave-active {
        opacity: 0;
    }

        .modal-enter .modal-container,
        .modal-leave-active .modal-container {
            -webkit-transform: scale(2);
            transform: scale(2);
        }
</style>
